import React from "react";

export default function Footer() {
    return(
        <>
        <div>Open sourced project coded by <a href="https://www.linkedin.com/in/mariana-pereira-b86b1382/" target="_blank" rel="noreferrer">Mariana Pereira</a></div>
        </>
    );
}